import { render } from "./ProfileAccountUpgradeSuccessful.vue?vue&type=template&id=c39fa9ce&scoped=true"
import script from "./ProfileAccountUpgradeSuccessful.vue?vue&type=script&lang=js"
export * from "./ProfileAccountUpgradeSuccessful.vue?vue&type=script&lang=js"

import "./ProfileAccountUpgradeSuccessful.vue?vue&type=style&index=0&id=c39fa9ce&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c39fa9ce"]])

export default __exports__